import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const LoginForm = ({ language, direction }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const mockCredentials = {
    lawyer: { email: 'avocat@legaloffice.ma', password: 'Lawyer@2026' },
    secretary: { email: 'secretaire@legaloffice.ma', password: 'Secretary@2026' },
    admin: { email: 'admin@legaloffice.ma', password: 'Admin@2026' },
    mouatamid: { email: 'mouatamid@avocatmanager.ma', password: 'tabriquet' }
  };

  const translations = {
    fr: {
      email: 'Adresse e-mail',
      emailPlaceholder: 'avocat@legaloffice.ma',
      password: 'Mot de passe',
      passwordPlaceholder: 'Entrez votre mot de passe',
      rememberMe: 'Se souvenir de moi',
      forgotPassword: 'Mot de passe oublié ?',
      signIn: 'Se connecter',
      invalidCredentials: 'Email ou mot de passe incorrect. Veuillez réessayer.',
      emailRequired: 'L\'adresse e-mail est requise',
      passwordRequired: 'Le mot de passe est requis',
      invalidEmail: 'Format d\'e-mail invalide'
    },
    ar: {
      email: 'عنوان البريد الإلكتروني',
      emailPlaceholder: 'avocat@legaloffice.ma',
      password: 'كلمة المرور',
      passwordPlaceholder: 'أدخل كلمة المرور الخاصة بك',
      rememberMe: 'تذكرني',
      forgotPassword: 'هل نسيت كلمة المرور؟',
      signIn: 'تسجيل الدخول',
      invalidCredentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة. يرجى المحاولة مرة أخرى.',
      emailRequired: 'عنوان البريد الإلكتروني مطلوب',
      passwordRequired: 'كلمة المرور مطلوبة',
      invalidEmail: 'تنسيق البريد الإلكتروني غير صالح'
    }
  };

  const t = translations?.[language];

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData?.email) {
      newErrors.email = t?.emailRequired;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(formData?.email)) {
      newErrors.email = t?.invalidEmail;
    }
    
    if (!formData?.password) {
      newErrors.password = t?.passwordRequired;
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    
    if (!validateForm()) return;
    
    setLoading(true);
    
    setTimeout(() => {
      const isValidCredentials = Object.values(mockCredentials)?.some(
        cred => cred?.email === formData?.email && cred?.password === formData?.password
      );
      
      if (isValidCredentials) {
        localStorage.setItem('language', language);
        localStorage.setItem('direction', direction);
        navigate('/dashboard');
      } else {
        setErrors({ general: t?.invalidCredentials });
      }
      
      setLoading(false);
    }, 1500);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e?.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    if (errors?.[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 md:space-y-5 lg:space-y-6" style={{ direction }}>
      {errors?.general && (
        <div className="flex items-start gap-3 p-3 md:p-4 bg-error/10 border border-error/20 rounded-lg">
          <Icon name="AlertCircle" size={20} className="text-error flex-shrink-0 mt-0.5" />
          <p className="text-sm text-error">{errors?.general}</p>
        </div>
      )}
      <Input
        type="email"
        name="email"
        label={t?.email}
        placeholder={t?.emailPlaceholder}
        value={formData?.email}
        onChange={handleChange}
        error={errors?.email}
        required
        className="w-full"
      />
      <Input
        type="password"
        name="password"
        label={t?.password}
        placeholder={t?.passwordPlaceholder}
        value={formData?.password}
        onChange={handleChange}
        error={errors?.password}
        required
        className="w-full"
      />
      <div className="flex items-center justify-between gap-4">
        <Checkbox
          name="rememberMe"
          label={t?.rememberMe}
          checked={formData?.rememberMe}
          onChange={handleChange}
        />
        
        <button
          type="button"
          className="text-sm text-primary hover:text-primary/80 transition-colors font-medium"
          onClick={() => console.log('Forgot password clicked')}
        >
          {t?.forgotPassword}
        </button>
      </div>
      <Button
        type="submit"
        variant="default"
        fullWidth
        loading={loading}
        iconName="LogIn"
        iconPosition="right"
        className="mt-6"
      >
        {t?.signIn}
      </Button>
    </form>
  );
};

export default LoginForm;